"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const companyGroupsService = {
  getCompanyGroups: function (options) {
    return api.get("/CompanyGroups", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createCompanyGroup: function (options) {
    return api.post("/CompanyGroups", {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  deleteCompanyGroup: function (options) {
    return api.delete("/CompanyGroups", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  addUnitGroups: function (options) {
    return api.post("/UnitGroups", {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  deleteUnitGroups: function (options) {
    return api.delete("/UnitGroups", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default companyGroupsService;
